module.exports = __webpack_public_path__ + "static/media/014-Aufraeumen_mV_ID_4.42b227ef.mp3";